import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import StatusBadge from './StatusBadge'
import ConfirmModal from '../ui/ConfirmModal'

function StudentActList() {
  const location = useLocation()
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const student_id = new URLSearchParams(location.search).get('student_id')
  const [resetTestId, setResetTestId] = useState(null)
  const [resetAllTest, setResetAllTest] = useState(false)

  const getStudents = async () => {
    let url = `${process.env.REACT_APP_BASE_URL}getallstdactstests?student_id=${student_id}`
    try {
      const response = await axios.get(url)
      if (response.status === 200) {
        setData(response.data)
      }
    } catch (error) {
      console.error('Error fetching students:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    setIsLoading(true)
    getStudents()
  }, [student_id])

  const ResetTest = (id) => {
    setResetTestId(id)
  }
  const ResetAllTest = () => {
    setResetAllTest(true)
  }

  // Handler for confirming reset of a single test
  const handleConfirmResetTest = async () => {
    if (resetTestId) {
      await axios.get(
        `${process.env.REACT_APP_BASE_URL}reset_acttest/${resetTestId}/${student_id}`
      )
      setResetTestId(null)
      getStudents()
      window.location.reload(true)
    }
  }
  // Handler for confirming reset of all tests
  const handleConfirmResetAllTest = async () => {
    await axios.get(
      `${process.env.REACT_APP_BASE_URL}reset_allacttest/${student_id}`
    )
    setResetAllTest(false)
    getStudents()
    window.location.reload(true)
  }

  const Result = async (id) => {
    navigate(`/act/testresults/${id}?student_id=${student_id}`)
  }

  // Helper to get status for badge
  const getStatusType = (item) => {
    if (item.test_status === true) return 'completed'
    if (item.test_status === false) return 'assigned'
    return 'not started'
  }

  return (
    <div className="bg-white border rounded-[10px] border-[#F0F0F0]">
      <div className="flex justify-between items-center px-5 pt-5">
        <div className="text-[#030303] text-lg leading-[21.6px] border-0 font-semibold">
          ACT Practice Test
        </div>
        <div className="flex gap-2">
          <Link
            to="/students"
            className="bg-[#DE3C7D] text-white px-4 py-2 rounded-md"
          >
            Back to Students
          </Link>
          {data.length > 0 && (
            <button
              className="bg-[#EFEFEF] text-[#DE3C7D] px-4 py-2 rounded-md border border-[#DE3C7D] font-medium hover:bg-[#DE3C7D] hover:text-white transition-colors"
              onClick={ResetAllTest}
            >
              Reset All Tests
            </button>
          )}
        </div>
      </div>
      <div className="overflow-x-auto mt-2">
        <table className="w-full">
          <thead className="bg-neutral-50">
            <tr>
              <th className="text-left border text-[#535862] text-sm leading-[16.8px] w-[70px] px-5 py-3.5 border-[#F0F0F0]">
                S.No
              </th>
              <th className="text-left border text-[#535862] text-sm leading-[16.8px] w-[240px] px-5 py-3.5 border-[#F0F0F0]">
                Tests Name
              </th>
              <th className="text-left border text-[#535862] text-sm leading-[16.8px] w-[170px] px-5 py-3.5 border-[#F0F0F0]">
                Test Code
              </th>
              <th className="text-left border text-[#535862] text-sm leading-[16.8px] w-[100px] px-5 py-3.5 border-[#F0F0F0]">
                English
              </th>
              <th className="text-left border text-[#535862] text-sm leading-[16.8px] w-[100px] px-5 py-3.5 border-[#F0F0F0]">
                Math
              </th>
              <th className="text-left border text-[#535862] text-sm leading-[16.8px] w-[100px] px-5 py-3.5 border-[#F0F0F0]">
                Reading
              </th>
              <th className="text-left border text-[#535862] text-sm leading-[16.8px] w-[100px] px-5 py-3.5 border-[#F0F0F0]">
                Science
              </th>
              <th className="text-left border text-[#535862] text-sm leading-[16.8px] w-[136px] px-5 py-3.5 border-[#F0F0F0]">
                Status
              </th>
              <th className="text-left border text-[#535862] text-sm leading-[16.8px] w-[120px] px-2 py-3.5 border-l border-[#F0F0F0]">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              Array.from({ length: 3 }).map((_, idx) => (
                <tr key={idx}>
                  {Array.from({ length: 9 }).map((_, colIdx) => (
                    <td
                      key={colIdx}
                      className={
                        colIdx === 8
                          ? 'flex gap-2.5 px-10 py-2 border-l border-[#F0F0F0]'
                          : 'border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]'
                      }
                    >
                      <div className="h-4 w-full bg-gray-200 animate-pulse rounded" />
                    </td>
                  ))}
                </tr>
              ))
            ) : data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item._id} className="border border-[#F0F0F0]">
                  <td className="border text-[#030303] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                    {String(index + 1).padStart(2, '0')}
                  </td>
                  <td className="border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                    {item.test_title}
                  </td>
                  <td className="border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                    {item.test_code}
                  </td>
                  {item.test_status === true ? (
                    <>
                      <td className="border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                        {item.english_scaleScore ?? '-'}
                      </td>
                      <td className="border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                        {item.math_scaleScore ?? '-'}
                      </td>
                      <td className="border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                        {item.reading_scaleScore ?? '-'}
                      </td>
                      <td className="border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                        {item.science_scaleScore ?? '-'}
                      </td>
                      <td className="border px-5 py-2 border-[#F0F0F0]">
                        <StatusBadge status={getStatusType(item)} />
                      </td>
                      <td className="flex gap-2.5 px-10 py-2 border-l border-[#F0F0F0]">
                        <button
                          className="bg-[#EFEFEF] flex items-center gap-1 p-2.5 rounded-md"
                          onClick={() => Result(item._id)}
                        >
                          <span className="text-[#030303] text-xs leading-[14.4px]">
                            View Results
                          </span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.08829 6.99995C9.08829 8.15495 8.15495 9.08829 6.99995 9.08829C5.84495 9.08829 4.91162 8.15495 4.91162 6.99995C4.91162 5.84495 5.84495 4.91162 6.99995 4.91162C8.15495 4.91162 9.08829 5.84495 9.08829 6.99995Z"
                              stroke="#535862"
                              strokeWidth="1.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M6.99991 11.8241C9.05908 11.8241 10.9782 10.6108 12.3141 8.51076C12.8391 7.68826 12.8391 6.30576 12.3141 5.48326C10.9782 3.38325 9.05908 2.16992 6.99991 2.16992C4.94074 2.16992 3.02158 3.38325 1.68574 5.48326C1.16074 6.30576 1.16074 7.68826 1.68574 8.51076C3.02158 10.6108 4.94074 11.8241 6.99991 11.8241Z"
                              stroke="#535862"
                              strokeWidth="1.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                        </button>
                        <button
                          className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0]"
                          onClick={() => ResetTest(item._id)}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.6999 16.4468C14.5599 15.6935 16.6666 13.0935 16.6666 10.0002C16.6666 6.32016 13.7066 3.3335 9.99992 3.3335C5.55325 3.3335 3.33325 7.04016 3.33325 7.04016M3.33325 7.04016V4.00016M3.33325 7.04016H4.67325H6.29325"
                              stroke="#535862"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M3.33325 10C3.33325 13.68 6.31992 16.6667 9.99992 16.6667"
                              stroke="#535862"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeDasharray="3 3"
                            ></path>
                          </svg>
                        </button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                        -
                      </td>
                      <td className="border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                        -
                      </td>
                      <td className="border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                        -
                      </td>
                      <td className="border text-[#535862] text-sm leading-[16.8px] px-5 py-2 border-[#F0F0F0]">
                        -
                      </td>
                      <td className="border px-5 py-2 border-[#F0F0F0]">
                        <StatusBadge status={getStatusType(item)} />
                      </td>
                      <td className="flex gap-2.5 px-10 py-2 border-l border-[#F0F0F0]">
                        -
                      </td>
                    </>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="9"
                  align="center"
                  className="py-8 text-[#535862] text-sm"
                >
                  No Data Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {resetTestId && (
        <ConfirmModal
          open={!!resetTestId}
          onCancel={() => setResetTestId(null)}
          onConfirm={handleConfirmResetTest}
          title="Reset Test"
          message="Are you sure you want to reset this test?"
        />
      )}
      {resetAllTest && (
        <ConfirmModal
          open={resetAllTest}
          onCancel={() => setResetAllTest(false)}
          onConfirm={handleConfirmResetAllTest}
          title="Reset All Tests"
          message="Are you sure you want to reset all tests?"
        />
      )}
    </div>
  )
}
export default StudentActList
